const getAllValueKeys = (obj) => {
	const keys = []

	const checkKey = (obj) => {
		Object.entries(obj).forEach(([key, value]) => {
			if (
				typeof value === 'string' ||
				Array.isArray(value) ||
				typeof value === 'number' ||
				typeof value === 'boolean'
			) {
				keys.push(key)
			}

			if (typeof value === 'object' && value !== null) {
				checkKey(value)
			}
		})
	}

	checkKey(obj)

	return keys
}

export { getAllValueKeys }
